import classNames from 'classnames';
import styles from './ArticleMedia.module.scss';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';

export interface UI_ArticleMediaProps {
	className?: string;
	image: {
		url: string;
		focalPoint?: { left: number; top: number };
		extension?: string;
		altText?: string;
	};
	caption: string;
}

export const UI_ArticleMedia = ({ className, image, caption }: UI_ArticleMediaProps) => (
	<figure className={classNames(styles.ArticleMedia, className)}>
		{image && (
			<span className={styles.ArticleMedia_mediabox}>
				<UI_Picture
					aspectRatio={0.4}
					focalPoint={image.focalPoint}
					url={image.url}
					altText={image.altText}
					sizes="(max-width: 1728px) 100vw, 1728px"
					imageCropping="cover"
					className={styles.ArticleMedia_mediabox}
					fileType={image.extension}
				/>
			</span>
		)}
		<figcaption className={styles.ArticleMedia_caption}>{caption}</figcaption>
	</figure>
);
